import { SumsubTokenResponse } from "@api/client";
import { ErrorHandler, PromisedTokenExpirationHandler } from "@sumsub/websdk";
import SumsubWebSdk from "@sumsub/websdk-react";
import { contractSumsubLogin } from "common/_redux/contract/actions";
import { useAppDispatch } from "core/store/hooks";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { EventPayloadExtension, MessageHandlerExtension } from "./types";

interface Props {
	show: boolean;
	onHide: (userId?: string) => void;
}

const SumsubModal: React.FC<Props> = (props) => {
	const { show, onHide } = props;

	const dispatch = useAppDispatch();

	const [sumsubLogin, setSumsubLogin] = useState<SumsubTokenResponse>();

	const getToken = () => {
		dispatch(contractSumsubLogin())
			.unwrap()
			.then((res) => {
				setSumsubLogin(res);
			});
	};

	const expirationHandler: PromisedTokenExpirationHandler = () => {
		return new Promise(() => {});
	};

	const onMessage: MessageHandlerExtension = (type, payload) => {
		// console.log("messageHandler", { type, payload });

		if (type == "idCheck.onApplicantStatusChanged") {
			let _payload = payload as EventPayloadExtension<"idCheck.applicantStatus">;

			// if (_payload.reviewStatus == "") {
			// 	onHide();
			// 	errorHandler(_payload?.reviewResult?.moderationComment, dispatch, true);
			// 	return;
			// }

			if (
				_payload.reviewStatus == "completed" &&
				sumsubLogin?.userId &&
				_payload?.reviewResult?.reviewAnswer == "GREEN"
			) {
				onHide(sumsubLogin.userId);

				return;
			}
		}
	};

	const onError: ErrorHandler = (err) => {
		// console.log("errorHandler", err);
	};

	useEffect(() => {
		if (show) {
			getToken();
		}
	}, [show]);

	if (!show || !sumsubLogin || !sumsubLogin?.token) return null;

	return (
		<Modal show={show} size="xl" onHide={() => onHide()} backdrop="static">
			<Modal.Header closeButton>
				<Modal.Title>Verifica Identità Self ID</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<SumsubWebSdk
					accessToken={sumsubLogin?.token}
					expirationHandler={expirationHandler}
					onMessage={onMessage}
					onError={onError}
					config={{
						lang: "it",
					}}
				/>
			</Modal.Body>
		</Modal>
	);
};
export default SumsubModal;
